import React, { useEffect, useRef } from 'react';
import { AuthenticatorQrCode } from '../../../shared/authenticator-qr-code/authenticator-qr-code';
import { LoadingDots } from '@workday/canvas-kit-react/loading-dots';
import { useRegisterNewAuthenticatorMutation, useVerifyNewAuthenticatorMutation } from '../../../slices/auth-api.slice';
import { useTranslation } from 'react-i18next';

interface ResetAuthenticatorStepProps {
    onNext: () => void;
}

export function ResetAuthenticatorStep({ onNext }: ResetAuthenticatorStepProps) {
    const initialRenderRef = useRef(true);
    const [registerNew, registerNewAuthenticatorMutation] = useRegisterNewAuthenticatorMutation();
    const [verifyNew, verifyNewAuthenticatorMutation] = useVerifyNewAuthenticatorMutation();
    const { t } = useTranslation('auth');

    useEffect(() => {
        if (initialRenderRef.current) {
            registerNew();
            initialRenderRef.current = false;
        }
    }, [registerNew]);

    useEffect(() => {
        if (verifyNewAuthenticatorMutation.isSuccess) {
            onNext();
        }
    }, [onNext, verifyNewAuthenticatorMutation.isSuccess]);

    function onSubmit(payload: { passcode: string }) {
        verifyNew({
            passcode: payload.passcode
        });
    }

    return (
        <div className='resetAuthenticator'>
            {registerNewAuthenticatorMutation.isSuccess ? (
                <AuthenticatorQrCode
                    title={t('Authenticator.title')}
                    authenticator={{
                        secret: registerNewAuthenticatorMutation.data.secret,
                        qrCodeUri: registerNewAuthenticatorMutation.data.qrCodeUri
                    }}
                    mutation={verifyNewAuthenticatorMutation}
                    onSubmit={onSubmit}
                />
            ) : (
                <LoadingDots role='progressbar' />
            )}
        </div>
    );
}
